import { AddressSuggestion } from '../types/AddressSuggestion';
import { getSuggestionKey } from './getSuggestionKey';

/**
 * Removes duplicate address suggestions based on street, city, state, and zipcode.
 * Keeps the first occurrence of each unique address. This is useful because the API
 * may return multiple suggestions that are identical except for the 'secondary' (line 2),
 * which we want the user to provide manually.
 */
export const deduplicateSuggestions = (
  suggestions: AddressSuggestion[],
): AddressSuggestion[] => {
  const seen = new Set<string>();
  const deduplicated: AddressSuggestion[] = [];

  for (const suggestion of suggestions) {
    const key = getSuggestionKey(suggestion);

    if (!seen.has(key)) {
      seen.add(key);
      deduplicated.push(suggestion);
    }
  }

  return deduplicated;
};
